<div class="sc-tooltip" (mouseenter)="toggleTooltip(true)" (mouseleave)="toggleTooltip(false)">
    <ng-content></ng-content>
    <div class="sc-tooltip__overlay" *ngIf="isMobile && isTooltipOpen"></div>
    <div class="sc-tooltip__content"
        [class.no-title]="!title"
        [class.no-description]="!description"
        [ngClass]="contentPositionClass" [class.open]="isTooltipOpen" #tooltipContent>
        <span class="sc-icon icon-close-elipse content__close-button" (click)="toggleTooltip(false)"
              *ngIf="isMobile"></span>
        <div class="content__title" *ngIf="title" [ngClass]="titleClasses" [innerHTML]="title"></div>
        <div class="content__description" *ngIf="description" [ngClass]="descriptionClasses" [innerHTML]="description"></div>
        <div class="content__carret" [ngClass]="carretPositionClass" *ngIf="isTooltipOpen"></div>
    </div>
</div>
